// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const TOAST_ERRORS_IN_FORM = "Ups, formul\u00e1r sa nepodarilo odosla\u0165. Niekde v \u0148om bude chyba.";
